export default __webpack_public_path__ + "static/media/groupavatar2.5eb0a291.png";